export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Get our application from your preferred platform. Installation takes just a few seconds and works on all major operating systems.',
      icon: 'ri-download-cloud-line',
      align: 'left'
    },
    {
      number: '02',
      title: 'Create Your Account',
      description: 'Sign up with your email address and choose your subscription plan. Your account will be ready instantly.',
      icon: 'ri-user-add-line',
      align: 'right'
    },
    {
      number: '03',
      title: 'Select a Server',
      description: 'Choose from our global network of high-speed servers. Pick the location that best suits your needs.',
      icon: 'ri-server-line',
      align: 'left'
    },
    {
      number: '04',
      title: 'Connect & Browse Securely',
      description: 'Click connect and enjoy complete online privacy. Your internet traffic is now encrypted and protected.',
      icon: 'ri-shield-check-line',
      align: 'right'
    }
  ];

  return (
    <section id="how-it-works" className="py-32 bg-white">
      <div className="max-w-5xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-thin text-gray-900 mb-4">Simple Setup Process</h2>
          <p className="text-base text-gray-500">Get started in minutes</p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-teal-500 via-purple-500 to-teal-500 transform -translate-x-1/2 hidden md:block"></div>

          {steps.map((step, index) => (
            <div key={index} className={`relative mb-20 last:mb-0 ${step.align === 'left' ? 'md:pr-1/2' : 'md:pl-1/2'}`}>
              <div className={`flex items-start gap-8 ${step.align === 'right' ? 'md:flex-row-reverse md:text-right' : ''}`}>
                <div className="hidden md:block absolute left-1/2 top-0 transform -translate-x-1/2 -translate-y-2">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-purple-600 rounded-full flex items-center justify-center shadow-lg">
                    <i className={`${step.icon} text-white text-xl`}></i>
                  </div>
                </div>

                <div className={`flex-1 ${step.align === 'left' ? 'md:pr-16' : 'md:pl-16'}`}>
                  <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300">
                    <div className="flex items-center gap-4 mb-4 md:hidden">
                      <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-purple-600 rounded-full flex items-center justify-center">
                        <i className={`${step.icon} text-white text-xl`}></i>
                      </div>
                      <span className="text-7xl font-thin text-purple-200">{step.number}</span>
                    </div>
                    <span className="hidden md:block text-7xl font-thin text-purple-200 mb-4">{step.number}</span>
                    <h3 className="text-3xl font-bold text-gray-900 mb-4">{step.title}</h3>
                    <p className="text-base text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
